import { Button } from "design-system/atoms/Button"
import {
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { Progress } from "design-system/atoms/Progress"
import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"
import { useCustomerImportStatusQuery } from "modules/customers/hooks/useCustomerImportStatusQuery"
import { Loading } from "modules/shared/components/Loading"
import { Trans, useTranslation } from "react-i18next"

type Props = {
  importId: string
  onClose: () => void
}

export function ImportProgress({ importId, onClose }: Props) {
  const { t } = useTranslation()
  const { data, isPending } = useCustomerImportStatusQuery(importId)
  const { data: employee } = useAuthEmployeeQuery()

  if (isPending || !data) return <Loading />

  const percent =
    data.totalRows === 0 ? 0 : Math.round((data.processedCount / data.totalRows) * 100)

  return (
    <>
      <DialogHeader>
        <DialogTitle>{t("customers.imports.progress.running.title")}</DialogTitle>
        <DialogDescription>{t("customers.imports.progress.running.description")}</DialogDescription>
        <DialogDescription>
          <Trans
            i18nKey="customers.imports.progress.running.description2"
            values={{ email: employee?.email }}
            components={{
              b: <span className="font-medium" />,
            }}
          />
        </DialogDescription>
      </DialogHeader>
      <div className="flex flex-col gap-4 py-4">
        <Progress value={percent} />
        <span className="text-sm text-muted-foreground">
          {t("customers.imports.progress.running.stats", {
            processedCount: data.processedCount,
            totalRows: data.totalRows,
            createdCount: data.createdCount,
            updatedCount: data.updatedCount,
            failedCount: data.failedCount,
          })}
        </span>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>
          {t("shared.close")}
        </Button>
      </DialogFooter>
    </>
  )
}
